(function(){
var R = document.querySelector(".atb2"); if(!R) return;
var CAT = window.__ATBC__ || {n:[],f:[],y:[],d:""};
var bar   = R.querySelector(".bar"),
wall  = R.querySelector(".wall"),
tiles = [].slice.call(wall.querySelectorAll(".bt")),
ltrs  = [].slice.call(wall.querySelectorAll(".ltr")),
q     = R.querySelector("#atbq"),
clr   = R.querySelector(".clr"),
sug   = R.querySelector(".sug"),
fbtn  = R.querySelector(".fbtn"),
flab  = fbtn.querySelector(".lb"),
fpan  = R.querySelector(".filters"),
xf    = R.querySelector(".xf"),
state = R.querySelector(".state"),
az    = R.querySelector(".az"),
jz    = [],
chips = [].slice.call(R.querySelectorAll(".chip"));
jz = [].slice.call(az.querySelectorAll(".jz"));
var lens = "";     /* equipment category, by index */
var typ  = "";     /* document type, by letter */
var open = null, sheet = null;
var DATA = null, pending = false, DEAD = false;
function need(then){
if(DATA){ then(); return; }
if(DEAD) return;
if(pending){ pending.push(then); return; }
pending = [then];
fetch(CAT.d, {credentials:"omit"}).then(function(r){ return r.text(); })
.then(function(txt){
var cut = txt.split("/*ATB*/");
DATA = JSON.parse(cut.length > 2 ? cut[1] : txt);
DATA.s = DATA.p.map(function(p){
return (p[1]+" "+DATA.b[p[2]]+" "+p[5]).replace(/&amp;/g,"&").toLowerCase();
});
var run = pending; pending = false;
run.forEach(function(f){ f(); });
})
.catch(function(){
pending = false; DEAD = true;
R.querySelector(".row1").style.display = "none";
});
}
(CAT.g || []).forEach(function(v, i){
var im = tiles[i] && tiles[i].querySelector("img");
if(!im || !v) return;
im.style.setProperty("--lh", v[0]);
im.style.setProperty("--lx", v[1]);
im.style.setProperty("--ly", v[2]);
});
function esc(s){ return String(s).replace(/&(?!#?\w+;)/g,"&amp;")
.replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }
function plural(n,w){ return n.toLocaleString()+" "+w+(n===1?"":"s"); }
function shows(t){ return t.style.display !== "none"; }
function has(list, v){ return (","+list+",").indexOf(","+v+",") > -1; }
function typeOk(p){ return !typ || p[6].indexOf(typ) > -1; }
function lensOk(p){ return !lens || String(p[3]) === lens; }
function mark(s, term){
var i = s.toLowerCase().indexOf(term);
if(i < 0 || !term) return esc(s);
return esc(s.slice(0,i))+"<mark>"+esc(s.slice(i,i+term.length))+"</mark>"+esc(s.slice(i+term.length));
}
R.addEventListener("error", function(e){
var t = e.target;
if(t.tagName === "IMG" && t.parentNode && t.parentNode.className === "mk"){
t.parentNode.parentNode.className += " nolg"; t.remove();
}
}, true);
var KEY = "atb.recent";
function readRecent(){
try{ return JSON.parse(localStorage.getItem(KEY)) || []; }catch(e){ return []; }
}
function remember(handle, title, brand){
try{
var list = readRecent().filter(function(r){ return r[0] !== handle; });
list.unshift([handle, title, brand]);
localStorage.setItem(KEY, JSON.stringify(list.slice(0,8)));
}catch(e){}
}
function paintRecent(){
var list = readRecent(), box = R.querySelector(".recent");
if(!list.length){ box.hidden = true; return; }
box.querySelector(".rr").innerHTML = list.map(function(r){
return '<a class="rc" href="/pages/'+r[0]+'"><span class="t">'+esc(r[1])+
'</span><span class="m">'+esc(r[2])+'</span></a>';
}).join("");
box.hidden = false;
}
R.addEventListener("click", function(e){
var a = e.target.closest ? e.target.closest("[data-set]") : null;
if(a) remember(a.getAttribute("data-set"), a.getAttribute("data-t"), a.getAttribute("data-b"));
});
function close(){
if(sheet){ sheet.remove(); sheet = null; }
var prev = wall.querySelector(".bt.on");
if(prev) prev.className = prev.className.replace(" on","");
open = null;
}
function setCard(p, showCat, i){
var brand = DATA.b[p[2]];
return '<a class="st'+(CAT.f[p[3]] === 1 ? " e" : "")+'" style="animation-delay:'+
Math.min(i,10)*22+'ms" href="/pages/'+p[0]+'" data-set="'+p[0]+'" data-t="'+esc(p[1])+
'" data-b="'+esc(brand)+'">'+
'<span class="sn">'+esc(p[1])+'</span><span class="sm">'+
(showCat ? CAT.n[p[3]]+' &middot; ' : '')+plural(p[4],"doc")+'</span></a>';
}
function openSheet(tile, only){
var bx = +tile.getAttribute("data-i");
if(open === bx && !only){ close(); return; }
close();
open = bx; tile.className += " on";
var rows = [];
for(var i=0;i<DATA.p.length;i++){
var p = DATA.p[i];
if(p[2] !== bx || !lensOk(p) || !typeOk(p)) continue;
if(only && only.indexOf(i) < 0) continue;
rows.push(p);
}
rows.sort(function(a,b){ return a[1] < b[1] ? -1 : 1; });
var docs = rows.reduce(function(a,p){ return a+p[4]; },0);
var spread = {}; rows.forEach(function(p){ spread[p[3]] = 1; });
var one = (rows.length && Object.keys(spread).length === 1) ? CAT.n[rows[0][3]] : "";
sheet = document.createElement("div");
sheet.className = "sheet";
sheet.innerHTML = '<div class="sh-hd"><h3>'+esc(DATA.b[bx])+'</h3><span class="sc">'+
plural(docs,"document")+' in '+plural(rows.length,"set")+(one ? ' &middot; '+one : '')+
'</span><button class="x" type="button" aria-label="Close">&times;</button></div>'+
'<div class="sets">'+rows.map(function(p,i){ return setCard(p, !one, i); }).join("")+'</div>'+
'<p class="sh-ft"><a href="'+tile.getAttribute("href")+'">Open the full '+
esc(DATA.b[bx])+' page</a></p>';
sheet.querySelector(".x").addEventListener("click", close);
var vis = tiles.filter(shows), top = tile.offsetTop, last = tile;
for(var j=0;j<vis.length;j++) if(vis[j].offsetTop === top) last = vis[j];
last.parentNode.insertBefore(sheet, last.nextSibling);
var box = sheet.getBoundingClientRect();
if(box.bottom > window.innerHeight)
window.scrollTo({top: box.top + window.pageYOffset - 128, behavior:"smooth"});
}
wall.addEventListener("click", function(e){
var t = e.target.closest ? e.target.closest(".bt") : null;
if(!t || DEAD) return;
e.preventDefault();
need(function(){ openSheet(t); });
});
document.addEventListener("keydown", function(e){
if(e.key !== "Escape") return;
if(!fpan.hidden){ shut(); fbtn.focus(); return; }
if(!sug.hidden){ hideSug(); return; }
bar.className = bar.className.replace(" open","");
close();
});
function paint(hits){
close();
var shown = 0, term = q.value.trim();
tiles.forEach(function(t){
var ok = true;
if(lens) ok = has(t.getAttribute("data-c"), lens);
if(ok && typ) ok = t.getAttribute("data-y").indexOf(typ) > -1;
if(ok && hits) ok = !!hits[+t.getAttribute("data-i")];
t.style.display = ok ? "" : "none";
var b = t.querySelector(".hit"); if(b) b.remove();
if(ok && hits){
var s = document.createElement("span");
s.className = "hit"; s.textContent = hits[+t.getAttribute("data-i")].length;
t.appendChild(s);
}
if(ok) shown++;
});
var quiet = !!(lens || typ || term);
ltrs.forEach(function(l){ l.style.display = quiet ? "none" : ""; });
az.hidden = quiet;
var v = R.querySelector(".void");
if(!shown && !v){
v = document.createElement("div");
v.className = "void";
v.innerHTML = '<b>Nothing under that</b><p>Try a shorter spelling, or the series name '+
'without the suffix. If it is a product we sell, we will track the document down for you.</p>';
wall.appendChild(v);
} else if(shown && v){ v.remove(); }
var bits = [];
if(term) bits.push('matching "'+term+'"');
if(typ)  bits.push(CAT.y[typ].toLowerCase());
if(lens) bits.push("in "+CAT.n[+lens]);
state.textContent = bits.length ? plural(shown,"brand")+" "+bits.join(", ") : "";
flab.textContent = lens ? CAT.n[+lens] : "All categories";
fbtn.className = lens ? "fbtn on " + lensFam : "fbtn";
xf.hidden = !lens;
}
function repaint(){
chips.forEach(function(o){
var on = o.getAttribute("data-k") === "t" ? (o.getAttribute("data-v") === typ)
: (o.getAttribute("data-v") === lens);
o.setAttribute("aria-pressed", String(on));
});
if(q.value.trim()) run(); else paint(null);
}
var lensFam = "";
function setLens(v, fam){ lens = v; lensFam = v ? (fam || "") : ""; shut(); repaint(); }
chips.forEach(function(c){
c.addEventListener("click", function(){
var kind = c.getAttribute("data-k"), v = c.getAttribute("data-v");
if(kind === "t"){ typ = (typ === v) ? "" : v; repaint(); }
else setLens(lens === v ? "" : v, /\be\b/.test(c.className) ? "e" : "w");
});
});
function shut(){
if(fpan.hidden) return;
fpan.hidden = true;
bar.className = bar.className.replace(" open","");
fbtn.setAttribute("aria-expanded","false");
}
function flip(){
if(!fpan.hidden){ shut(); return; }
fpan.hidden = false;
bar.className += " open";
fbtn.setAttribute("aria-expanded","true");
}
fbtn.addEventListener("click", flip);
xf.addEventListener("click", function(){ setLens(""); });
document.addEventListener("click", function(e){
if(!bar.contains(e.target)) shut();
});
var pick = -1, rows = [];
function hideSug(){ sug.hidden = true; pick = -1; }
function drawSug(list, term){
rows = list;
if(!list.length){ hideSug(); return; }
sug.innerHTML = '<p class="hd">Jump straight to</p>' + list.map(function(p, i){
return '<button class="sg" type="button" data-n="'+i+'" role="option" aria-selected="false">'+
'<span class="tx"><span class="t">'+mark(p[1].replace(/&amp;/g,"&"), term)+'</span>'+
'<span class="m">'+esc(DATA.b[p[2]])+'</span></span>'+
'<span class="r">'+plural(p[4],"doc")+'</span></button>';
}).join("");
sug.hidden = false;
}
function move(d){
if(sug.hidden || !rows.length) return;
pick = (pick + d + rows.length) % rows.length;
[].slice.call(sug.querySelectorAll(".sg")).forEach(function(el, i){
el.setAttribute("aria-selected", String(i === pick));
if(i === pick) el.scrollIntoView({block:"nearest"});
});
}
function go(i){
var p = rows[i]; if(!p) return;
remember(p[0], p[1].replace(/&amp;/g,"&"), DATA.b[p[2]]);
location.href = "/pages/"+p[0];
}
sug.addEventListener("click", function(e){
var b = e.target.closest ? e.target.closest(".sg") : null;
if(b) go(+b.getAttribute("data-n"));
});
q.addEventListener("keydown", function(e){
if(e.key === "ArrowDown"){ e.preventDefault(); move(1); }
else if(e.key === "ArrowUp"){ e.preventDefault(); move(-1); }
else if(e.key === "Enter" && pick > -1){ e.preventDefault(); go(pick); }
});
q.addEventListener("blur", function(){ setTimeout(hideSug, 160); });
function run(){
var term = q.value.trim().toLowerCase();
clr.hidden = !term;
if(!term){ hideSug(); paint(null); return; }
need(function(){
var hits = {}, top = [];
for(var i=0;i<DATA.p.length;i++){
var p = DATA.p[i];
if(!lensOk(p) || !typeOk(p) || DATA.s[i].indexOf(term) < 0) continue;
(hits[p[2]] = hits[p[2]] || []).push(i);
if(top.length < 8) top.push(p);
}
for(var b=0;b<DATA.b.length;b++)
if(!hits[b] && DATA.b[b].toLowerCase().indexOf(term) > -1) hits[b] = [];
var keys = Object.keys(hits);
keys.forEach(function(b){
if(hits[b].length) return;
for(var i=0;i<DATA.p.length;i++){
var p = DATA.p[i];
if(p[2] === +b && lensOk(p) && typeOk(p)){
hits[b].push(i);
if(top.length < 8) top.push(p);
}
}
});
drawSug(top, term);
paint(hits);
if(keys.length === 1){
var only = tiles.filter(function(x){ return x.getAttribute("data-i") === keys[0]; })[0];
if(only) openSheet(only, hits[keys[0]]);
}
});
}
var tmr;
q.addEventListener("input", function(){ clearTimeout(tmr); tmr = setTimeout(run, 110); });
clr.addEventListener("click", function(){ q.value = ""; run(); q.focus(); });
function letterTop(L){
for(var i=0;i<ltrs.length;i++)
if(ltrs[i].getAttribute("data-l") === L)
return ltrs[i].getBoundingClientRect().top + window.pageYOffset;
return null;
}
az.addEventListener("click", function(e){
var b = e.target.closest ? e.target.closest(".jz") : null;
if(!b || /\boff\b/.test(b.className)) return;
var top = letterTop(b.getAttribute("data-l"));
if(top == null) return;
close();
var lands = R.querySelector(".row1").offsetHeight + az.offsetHeight + 26;
window.scrollTo({top: Math.max(0, top - lands - 10), behavior:"smooth"});
});
function markLetter(){
if(az.hidden) return;
var edge = bar.getBoundingClientRect().bottom + 24, cur = null;
for(var i=0;i<ltrs.length;i++){
if(ltrs[i].getBoundingClientRect().top > edge) break;
cur = ltrs[i].getAttribute("data-l");
}
jz.forEach(function(b){
var on = b.getAttribute("data-l") === cur;
if(on !== /\bhere\b/.test(b.className))
b.className = on ? b.className+" here" : b.className.replace(" here","");
});
}
var head = R.querySelector(".top");
var ticking = false;
function onScroll(){
var stuck = window.pageYOffset > head.offsetHeight - 6;
if(stuck !== /\bstuck\b/.test(bar.className))
bar.className = stuck ? bar.className+" stuck"
: bar.className.replace(" stuck","");
markLetter();
}
window.addEventListener("scroll", function(){
if(ticking) return;
ticking = true;
requestAnimationFrame(function(){ ticking = false; onScroll(); });
}, {passive:true});
onScroll();
paintRecent();
if(window.requestIdleCallback) requestIdleCallback(function(){ need(function(){}); });
else setTimeout(function(){ need(function(){}); }, 1200);
})();